var map = {
	"./news1.jpg": 8101,
	"./news10.jpg": 3497,
	"./news11.jpg": 6620,
	"./news12.jpg": 1275,
	"./news13.jpg": 3230,
	"./news14.jpg": 8853,
	"./news15.jpg": 4536,
	"./news16.jpg": 4519,
	"./news17.jpg": 6778,
	"./news18.jpg": 4241,
	"./news19.jpg": 6084,
	"./news2.jpg": 2378,
	"./news20.jpg": 1848,
	"./news3.jpg": 119,
	"./news4.jpg": 2220,
	"./news5.jpg": 9097,
	"./news6.jpg": 8830,
	"./news7.png": 5459,
	"./news8.jpg": 2592,
	"./news9.jpg": 7485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4899;